module.exports = __webpack_public_path__ + "img/2.8e31e9d2.png";